import { GreenLabelTag, OrangeLabelTag, RedLabelTag } from '../../../../assets/icons';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { ROUTES, TEXT } from '../../../../constants';

const labels = {
  [`Low Priority`]: { color: 'yellow', text: 'Low Priority', flag: <GreenLabelTag /> },
  ['Make First Order']: { color: 'orange', text: 'Make First Order', flag: <OrangeLabelTag /> },
  ['Priority']: { color: 'red', text: 'Priority', flag: <RedLabelTag /> },
};

export const RedTile = ({ lot }) => {
  return (
    <div className="col-xl-2 col-lg-4 col-6 custom-col" style={{ height: '149px' }}>
      <div className="w-100 h-100 tiles">
        <Flag
          label={labels}
          priority={lot.priority}
          ready_status={lot?.ready_status}
          qty_status={lot?.qty_status}
        />
        <Content lot={lot} color={'bright-orange'} />
      </div>
    </div>
  );
};

export const YellowTile = ({ lot }) => {
  return (
    <div className="col-xl-2 col-lg-4 col-6 custom-col" style={{ height: '149px' }}>
      <div className="w-100 h-100 tiles">
        <Flag
          label={labels}
          ready_status={lot?.ready_status}
          priority={lot.priority}
          qty_status={lot?.qty_status}
        />
        <Content lot={lot} color={'yellow'} />
      </div>
    </div>
  );
};

export const GreenTile = ({ lot }) => {
  return (
    <div className="col-xl-2 col-lg-4 col-6 custom-col" style={{ height: '149px' }}>
      <div className="w-100 h-100 tiles">
        <Flag
          label={labels}
          priority={lot.priority}
          qty_status={lot?.qty_status}
          ready_status={lot?.ready_status}
          forceReadyCompleted={true} // ✅ force "Completed" for green tiles
        />
        <Content lot={lot} color={'light-green'} />
      </div>
    </div>
  );
};

const getTextColor = (bgColor) => {
  // Adjust this mapping based on actual class names or hex values
  switch (bgColor) {
    case 'bright-orange':
      return 'white';
    case 'yellow':
    case 'light-green':
    default:
      return 'black';
  }
};

const getReadyStatusColor = (ready_status) => {
  switch (ready_status) {
    case 'Not Ready':
      return 'bright-orange';
    case 'Partially Ready':
      return 'yellow';
    case 'Ready':
    default:
      return 'light-green';
  }
};

const Flag = ({ label, priority, ready_status, qty_status, forceReadyCompleted = false }) => {
  const readyColor = forceReadyCompleted ? 'light-green' : getReadyStatusColor(ready_status);
  const readyTextColor = getTextColor(readyColor);
  const priorityTextColor = getTextColor(label[priority]?.color);

  return (
    <div className="label-tag position-relative">
      {/* Top-left Priority Label */}
      {qty_status !== 'Completed' && (
        <div
          className={`tag ${label[priority]?.color} position-absolute`}
          style={{ top: 0, left: 0, color: priorityTextColor }}>
          {label[priority]?.text}
        </div>
      )}

      {/* Bottom-right Ready Status Label */}
      <div
        className={`tag ${readyColor} position-absolute`}
        style={{ bottom: 0, right: 0, color: readyTextColor, top: '133px' }}>
        {ready_status}
      </div>
    </div>
  );
};

const Content = ({ lot, color }) => {
  const navigate = useNavigate();
  const clickHandler = (lot) => {
    navigate(`${ROUTES.MANUFACTURING}/${lot.url}`, {
      state: { id: lot.id, product_id: lot?.product_id },
    });
  };
  return (
    <div
      className="main-container-matrix flex-column d-flex align-items-center justify-content-center"
      onClick={() => clickHandler(lot)}>
      <div className={`lot-num ${color} w-100 d-flex align-items-center justify-content-center`}>
        {lot.lot_no}
      </div>
      <div className="num2">SKU-{lot.SKU}</div>
      <div className="progress-bar-container w-100">
        <div className="progress">
          <div
            className={`progress-bar ${color}`}
            role="progressbar"
            style={{ width: `${(lot.ready_qty / lot.total_qty) * 100}%` }}
            aria-valuenow="55"
            aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
      </div>
      <div className="num3 text-center">
        {TEXT.ORDER_STATUS}{' '}
        <span>
          {lot.ready_qty}/{lot.total_qty}
        </span>
      </div>
    </div>
  );
};
